import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { useLanguage } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { useTheme } from './contexts/ThemeContext';
import { SoundProvider } from './contexts/SoundContext';
import ParticlesBackground from './components/ParticlesBackground';
import CalculatorPage from './components/CalculatorPage';
import PilotCalculatorPage from './components/PilotCalculatorPage';
import ModCalculatorPage from './components/ModCalculatorPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import CheckMyStats from './pages/CheckMyStats';
import LegendarySkins from './pages/LegendarySkins';
import AdminApp from './admin/AdminApp';
import Clarity from '@microsoft/clarity';

const PAGE_NAMES = {
  '/': 'mech_weapon_calculator',
  '/pilot-upgrade-calculator': 'pilot_calculator',
  '/mod-calculator': 'mod_calculator',
  '/my-stats': 'my_stats',
  '/legendary-skins': 'legendary_skins',
  '/privacy-policy': 'privacy_policy',
  '/terms-of-use': 'terms_of_use',
};

function ClarityTracker() {
  const location = useLocation();
  const { resolvedTheme } = useTheme();
  const { language } = useLanguage();

  const clarityReady = typeof window !== 'undefined' && typeof window.clarity === 'function';

  // Track route changes — critical for per-page heatmaps in a SPA
  useEffect(() => {
    if (!clarityReady) return;
    const pageName = PAGE_NAMES[location.pathname] || location.pathname.replace('/', '') || 'home';
    Clarity.setTag('page', pageName);
  }, [location.pathname, clarityReady]);

  // Tag session with user's theme preference
  useEffect(() => {
    if (!clarityReady) return;
    Clarity.setTag('theme', resolvedTheme);
  }, [resolvedTheme, clarityReady]);

  // Tag session with user's language preference
  useEffect(() => {
    if (!clarityReady) return;
    Clarity.setTag('language', language);
  }, [language, clarityReady]);

  return null;
}

function AppContent() {
  return (
    <Router>
      <ClarityTracker />
      <Routes>
        <Route path="/" element={<CalculatorPage />} />
        <Route path="/pilot-upgrade-calculator" element={<PilotCalculatorPage />} />
        <Route path="/mod-calculator" element={<ModCalculatorPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/my-stats" element={<CheckMyStats />} />
        <Route path="/legendary-skins" element={<LegendarySkins />} />
        <Route path="/admin/*" element={<AdminApp />} />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <SoundProvider>
          <AppContent />
        </SoundProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
